import {
  PRODUCT_SUCCESS,
  PRODUCT_FAIL,
  PRODUCT_EDIT,
  PRODUCT_ADD,
  GET_PRODUCTS_LISTING,
  GET_PRODUCTS_LISTING_SUCCESS,
  GET_PRODUCTS_LISTING_FAILED,
  PRODUCT_EDIT_SUCCESS,
  PRODUCT_EDIT_FAIL,
  PRODUCT_UPDATE,
  PRODUCT_UPDATE_SUCCESS,
  PRODUCT_UPDATE_FAIL,
  PRODUCT_IMAGE_DELETE,
  PRODUCT_IMAGE_DELETE_SUCCESS,
  PRODUCT_IMAGE_DELETE_FAIL,
  PRODUCT_DELETE,
  PRODUCT_DELETE_SUCCESS,
  PRODUCT_DELETE_FAIL,
  CHANGE_PRODUCT_STATUS,
  CHANGE_PRODUCT_STATUS_SUCCESS,
  CHANGE_PRODUCT_STATUS_FAIL,
} from "./actionTypes"

const initialState = {
  error: null,
  loading: false,
  msg: null,
  product: [],
  productEdit: null,
  productUpdate: null,
  productImg: null,
  productDelete: null,
}

const product = (state = initialState, action) => {
  switch (action.type) {
    case PRODUCT_ADD:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        product: action.payload,
        productEdit: null,
        productImg: null,
      }
      break
      case PRODUCT_SUCCESS:
      state = {
        ...state,
        loading: false,
        error: null,
        msg: null,
        product: action.payload,
        product: [], // new blank array, remove perevious value and creat a new array
      }
      break
    case PRODUCT_FAIL:
      state = {
        ...state,
        loading: false,
        msg: null,
        error: action.payload ? action.payload : null,
      }
      break
    case PRODUCT_EDIT:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        productEdit: action.payload,
      }
      break
    case PRODUCT_EDIT_SUCCESS:
      if (state === null || state.product.length === 0) {
        state = {
          ...state,
          loading: false,
          error: null,
          msg: null,
          product: [...state.product, action.payload],
        }
      } else {
        state = {
          ...state,
          loading: false,
          product: state.product.map(i =>
            i.prod_id === action.payload.prod_id ? action.payload : i
          ),
        }
      }
      break
    case PRODUCT_EDIT_FAIL:
      state = {
        ...state,
        loading: false,
        msg: null,
        error:
          action.payload !== "light"
            ? action.payload
            : "" !== "light"
            ? action.payload
            : "",
      }
      break
    case PRODUCT_UPDATE:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        productUpdate: action.payload,
      }
      break
    case PRODUCT_UPDATE_SUCCESS:
      state = { ...state, error: null,  msg: null, loading: false }
      break
    case PRODUCT_UPDATE_FAIL:
      state = {
        ...state,
        loading: false,
        msg: null,
        error:
          action.payload !== "light"
            ? action.payload
            : "" !== "light"
            ? action.payload
            : "",
      }
      break
    case GET_PRODUCTS_LISTING:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        product: action.payload,
        productEdit: null,
        productImg: null,
      }
      break
    case GET_PRODUCTS_LISTING_SUCCESS:
      state = { ...state, loading: false, msg: null, error: null, product: action.payload }
      break
    case GET_PRODUCTS_LISTING_FAILED:
      state = {
        ...state,
        loading: false,
        msg: null,
        error:
          action.payload !== "light"
            ? action.payload
            : "" !== "light"
            ? action.payload
            : "",
      }
      break

    case PRODUCT_IMAGE_DELETE:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        productImg: action.payload,
      }
      break
    case PRODUCT_IMAGE_DELETE_SUCCESS:
      const productindex = state.product.findIndex(
        product =>
          parseInt(product.prod_id) === parseInt(action.payload.prod_id)
      )

      // console.log("PRODUCT_IMAGE_DELETE_SUCCESS ", productindex)
      // console.log("action.payload ", action.payload)
      let newImageAfterImage = []
      newImageAfterImage = []
      newImageAfterImage = [...state.product] //making a new array
      newImageAfterImage[productindex][action.payload.img_name] = null
      newImageAfterImage[productindex][action.payload.img_name + "_id"] = null

      // console.log("newImageAfterImage ", newImageAfterImage)
      state = {
        ...state,
        loading: false,
        error: null,
        msg: null,
        product: newImageAfterImage,
      }
      break
    case PRODUCT_IMAGE_DELETE_FAIL:
      state = {
        ...state,
        loading: false,
        productImg: null,
        msg: null,
        error:
          action.payload !== "light"
            ? action.payload
            : "" !== "light"
            ? action.payload
            : "",
      }
      break

    case PRODUCT_DELETE:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        productDelete: action.payload,
      }
      break
    case PRODUCT_DELETE_SUCCESS:
      state = {
        ...state,
        loading: false,
        error: null,
        product: state.product.filter(product => {
          return product.prod_id !== action.payload.id
        }),
      }
      break

    case PRODUCT_DELETE_FAIL:
      return {
        ...state,
        msg: null,
        error:
          action.payload !== "light"
            ? action.payload
            : "" !== "light"
            ? action.payload
            : "",
        loading: false,
      }

    case CHANGE_PRODUCT_STATUS:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
      }
      break
    case CHANGE_PRODUCT_STATUS_SUCCESS:
      const index = state.product.findIndex(
        product => product.prod_id === action.payload.id
      )
      let newProductAfterStatusChange = []
      newProductAfterStatusChange = [...state.product] //making a new array
      newProductAfterStatusChange[index].product_status =
        !newProductAfterStatusChange[index].product_status

      state = {
        ...state,
        loading: false,
        error: null,
        msg: null,
        product: newProductAfterStatusChange,
      }

      break

    case CHANGE_PRODUCT_STATUS_FAIL:
      state = {
        ...state,
        loading: false,
        msg: null,
        error:
          action.payload !== "light"
            ? action.payload
            : "" !== "light"
            ? action.payload
            : "",
      }
      break

    default:
      state = { ...state, loading: false, error: null }
      break
  }
  return state
}

export default product
